import {animateInViewport} from "../transition";


$( '.property-carousel' ).each( function() {
	let $this = $( this );
	let index = 1;
	let isPaused = false; // Flag to control the pause state
	let indexAfterHover = 0; // Index to resume the loop after hover

	function handleActiveIndex() {
		setTimeout( () => {
			if ( !isPaused ) { // Only update if not paused
				const $slides = $this.find( '.swiper-slide' ); // Get all slides
				$slides.removeClass( 'current-slide' ); // Remove the class from all slides

				// Calculate the correct index considering the loop
				const slideCount = $slides.length;
				const currentIndex = index % slideCount;

				$slides.eq( currentIndex ).addClass( 'current-slide' ); // Add the class to the current slide
				index++; // Increment the index
			}
			handleActiveIndex(); // Recursively call the function to continue the loop
		}, 3000 );
	}

	let swiper = new Swiper( this, {
		slidesPerView: 1.5,
		spaceBetween: 10,
		speed: 1500,
		autoplay: {
			delay: 3000,
		},
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
		breakpoints: {
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
		loop: true,
	} );

	swiper.on( 'slideChange slideChangeTransitionEnd', function() {
		animateInViewport();
	} );

	handleActiveIndex();

	$( this ).on( 'mouseenter', function() {
		isPaused = true; // Pause the class update
		$this.addClass( 'paused' ).removeClass( 'play' );
		indexAfterHover = index; // Save the index to resume the loop
	} );

	$( this ).on( 'mouseleave', function() {
		isPaused = false; // Resume the class update
		$this.addClass( 'play' ).removeClass( 'paused' );
		index = indexAfterHover; // Restore the index to resume
	} );
} );

$( '.image-carousel' ).each( function() {
	const $this = $( this );

	let swiper = new Swiper( this, {
		navigation: {
			nextEl: $this.parents( '.carousel-container' ).find( '.carousel-next' )[ 0 ],
			prevEl: $this.parents( '.carousel-container' ).find( '.carousel-previous' )[ 0 ],
		},
		grabCursor: true,
		slidesPerView: 1.2,
		spaceBetween: 10,
		loop: false,
		breakpoints: {
			1024: {
				spaceBetween: 20,
			},
		},
	} );

	swiper.on( 'slideChange slideChangeTransitionEnd', function() {
		animateInViewport();
	} );
} );
